import Konva from 'konva'
import type KonvaType from 'konva'
import { useCallback } from 'react'

const MAP_MOVE_DURATION = 0.9

export const useZoomToPoint = () => {
  const zoomToPoint = useCallback(
    (
      stage: KonvaType.Stage | null,
      x: number,
      y: number,
      scale = 0.7,
      animate = true,
    ) => {
      if (!stage) return

      const pos = {
        x: stage.width() / 2 - x * scale,
        y: stage.height() / 2 - y * scale,
      }

      if (animate) {
        stage.to({
          scaleX: scale,
          scaleY: scale,
          x: pos.x,
          y: pos.y,
          duration: MAP_MOVE_DURATION,
          easing: Konva.Easings.EaseInOut,
        })
      } else {
        stage.stop()
        stage.scale({ x: scale, y: scale })
        stage.position(pos)
        stage.batchDraw()
      }
    },
    [],
  )

  return { zoomToPoint }
}
